import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import dayjs from 'dayjs';
import 'dayjs/locale/th';

dayjs.locale('th');

const ACTION_META = {
    CREATE: { label: 'สร้าง', color: '#28a745', icon: 'fas fa-plus-circle' },
    UPDATE: { label: 'แก้ไข', color: '#17a2b8', icon: 'fas fa-edit' },
    DELETE: { label: 'ลบ', color: '#dc3545', icon: 'fas fa-trash' }
};

export class ProgramLog extends Component {
    constructor(props) {
        super(props);
        this.state = { list: [], loading: true, search: '', actionFilter: '' };
    }

    componentDidMount() { this.load(); }

    load() {
        this.setState({ loading: true });
        fetch('api/programplus/logs?limit=500')
            .then(r => r.ok ? r.json() : [])
            .then(list => this.setState({ list, loading: false }))
            .catch(() => this.setState({ loading: false }));
    }

    getFiltered() {
        var { list, search, actionFilter } = this.state;
        var s = search.trim().toLowerCase();
        return list.filter(l => {
            if (actionFilter && l.action !== actionFilter) return false;
            if (!s) return true;
            return (l.username || '').toLowerCase().includes(s)
                || (l.displayName || '').toLowerCase().includes(s)
                || (l.programCode || '').toLowerCase().includes(s)
                || (l.programName || '').toLowerCase().includes(s);
        });
    }

    render() {
        var { loading, search, actionFilter } = this.state;
        var filtered = this.getFiltered();

        return (
            <div style={{ padding: 20 }}>
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <p style={{ margin: 0, fontSize: 13, color: '#888' }}>ทั้งหมด {filtered.length} รายการ</p>
                    <button className="btn btn-outline-secondary btn-sm" onClick={() => this.load()}><i className="fas fa-sync"></i> รีเฟรช</button>
                </div>

                <div style={{ background: '#fff', borderRadius: 10, padding: 14, boxShadow: '0 2px 12px rgba(0,0,0,0.06)', marginBottom: 16 }}>
                    <div className="d-flex flex-wrap" style={{ gap: 8 }}>
                        <button className={'btn btn-sm ' + (actionFilter === '' ? 'btn-dark' : 'btn-outline-secondary')} onClick={() => this.setState({ actionFilter: '' })}>ทั้งหมด</button>
                        {Object.keys(ACTION_META).map(k => {
                            var a = ACTION_META[k];
                            return <button key={k} className={'btn btn-sm ' + (actionFilter === k ? 'btn-dark' : 'btn-outline-secondary')}
                                onClick={() => this.setState({ actionFilter: k })}>
                                <i className={a.icon} style={{ color: a.color }}></i> {a.label}
                            </button>;
                        })}
                        <div className="input-group" style={{ maxWidth: 320, marginLeft: 'auto' }}>
                            <span className="input-group-text" style={{ background: '#fff' }}><i className="fas fa-search" style={{ color: '#aaa' }}></i></span>
                            <input className="form-control" placeholder="ค้นหา user, โค้ด, ชื่อ..." value={search} onChange={e => this.setState({ search: e.target.value })} style={{ borderLeft: 'none' }} />
                        </div>
                    </div>
                </div>

                {loading ? (
                    <div className="text-center py-5"><div className="spinner-border text-danger"></div></div>
                ) : filtered.length === 0 ? (
                    <div className="text-center py-5" style={{ color: '#bbb' }}>
                        <i className="fas fa-history" style={{ fontSize: 48, display: 'block', marginBottom: 12 }}></i>
                        ยังไม่มีประวัติ
                    </div>
                ) : (
                    <div style={{ background: '#fff', borderRadius: 10, boxShadow: '0 2px 12px rgba(0,0,0,0.06)', overflow: 'hidden' }}>
                        <table className="table table-hover" style={{ margin: 0 }}>
                            <thead style={{ background: '#f8f9fa' }}>
                                <tr>
                                    <th style={{ width: 170 }}>เวลา</th>
                                    <th style={{ width: 110 }}>การทำงาน</th>
                                    <th>โปรแกรม</th>
                                    <th style={{ width: 220 }}>ผู้ใช้งาน</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filtered.map(l => {
                                    var a = ACTION_META[l.action] || { label: l.action, color: '#888', icon: 'fas fa-circle' };
                                    return (
                                        <tr key={l.id}>
                                            <td style={{ fontSize: 13, color: '#555', whiteSpace: 'nowrap' }}>
                                                <i className="far fa-clock" style={{ color: '#bbb', marginRight: 4 }}></i>
                                                {l.timestamp ? dayjs(l.timestamp).format('DD MMM YYYY HH:mm') : '-'}
                                            </td>
                                            <td><span style={{ background: a.color, color: '#fff', padding: '3px 10px', borderRadius: 12, fontSize: 12, fontWeight: 700 }}><i className={a.icon}></i> {a.label}</span></td>
                                            <td>
                                                {l.programCode && <span style={{ fontSize: 11, background: '#eee', padding: '2px 8px', borderRadius: 4, marginRight: 6, color: '#666' }}>{l.programCode}</span>}
                                                {l.action === 'DELETE' ? (
                                                    <span style={{ color: '#888', textDecoration: 'line-through' }}>{l.programName || '(deleted)'}</span>
                                                ) : (
                                                    <Link to={'/console/programplus/edit/' + l.programId} style={{ fontWeight: 600, color: '#333' }}>{l.programName || '(no name)'}</Link>
                                                )}
                                            </td>
                                            <td>
                                                <i className="fas fa-user-circle" style={{ color: '#aaa', marginRight: 6 }}></i>
                                                <strong>{l.username || '-'}</strong>
                                                {l.displayName && <span style={{ color: '#888', fontSize: 12, marginLeft: 6 }}>({l.displayName})</span>}
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>
        );
    }
}
